import apiClient from '../../core/apiClient';
import { PricingExperiment, PaymentSummaryResponse } from '../../types/api';

export const pricingService = {
  getPricingAnalytics: async () => {
    const response = await apiClient.get<PricingExperiment[]>('/api/pricing/analytics');
    return response.data;
  },
  getExperiments: async () => {
    const response = await apiClient.get<PricingExperiment[]>('/api/pricing/experiments');
    return response.data;
  },
  approveRecommendation: async (recId: string, reason: string) => {
    const response = await apiClient.post(`/api/superadmin/pricing/approve/${recId}`, { reason });
    return response.data;
  },
  getPaymentHistory: async () => {
    const response = await apiClient.get<PaymentSummaryResponse>('/api/finance/payments');
    return response.data;
  }
};
